import React, { useEffect, useState } from 'react';
import { Select } from 'tea-component';
import { arrayToSimpleObj } from '@/pages/opinion/utils';
import { useIntl } from 'umi';
import BubbleCommon from '../../../BubbleCommon';
import { NO_DATE } from '@/pages/opinion/constants';
import './index.scss';
import classNames from 'classnames';

const SortBySelect = ({
  onChange,
  key,
  defaultValue = '',
  borderNone = false,
  defaultParams: {
    options,
    defaultBtnText = '',
    btnTextPrefix = '',
    footer = null,
    tipsMap = null,
    dealwithButton,
    needFormatMessage = true,
    className,
    ...restParams
  },
}: any) => {
  const { formatMessage } = useIntl();
  const [selectValue, setSelectValue] = useState(defaultValue);


  const textMap = arrayToSimpleObj(options, 'text');
  const btnTextMap = arrayToSimpleObj(options, 'btnText');

  useEffect(() => {
    if (defaultValue !== selectValue) {
      setSelectValue(defaultValue);
    }
  }, [defaultValue]);

  return (
    <div className={classNames({
      'dbo-singleselect-factory-wrapper': true,
      'dbo-singleselect-factory-wrapper--borderNone': borderNone,
      [className]: !!className
    })}>
      <Select
        className="select-item dbo-singleselect-factory"
        appearance="button"
        size="m"
        listHeight={252}
        options={options.map((item: any) => ({
          ...item,
          text:
            typeof item.text === 'string' && needFormatMessage
              ? formatMessage({ id: item.text })
              : item.text,
        }))}
        value={selectValue}
        onChange={(value) => {
          setSelectValue(value);
          onChange?.(key, value);
        }}
        button={
          <div className="select-button">
            {btnTextPrefix ? (
              <span className="select-button-text">{btnTextPrefix} </span>
            ) : null}
            <span className="select-button-value">
              {dealwithButton
                ? dealwithButton(selectValue, { options, btnTextMap, textMap })
                : formatMessage({
                  id:
                    btnTextMap[selectValue] ||
                    textMap[selectValue] ||
                    defaultBtnText ||
                    NO_DATE.EMPTY,
                })}
            </span>
          </div>
        }
        footer={footer}
        {...restParams}
      />
      {tipsMap && (
        <BubbleCommon
          tipsMap={tipsMap || null}
          placement={'right'}
          iconStyle={{
            marginRight: 0,
            marginLeft: -4,
            top: 8,
            position: 'relative',
          }}
        ></BubbleCommon>
      )}
    </div>
  );
};

export default SortBySelect;
